import Aqumen from "@aqumen/sdk";
import React, {useState} from "react";
import {useIntl} from "react-intl";

import {DisplayId} from "@/library/display/display_id.jsx";

import {CompilerActionsTile} from "./compiler_actions_tile.jsx";
import {CompilerInputsTile} from "./compiler_inputs_tile.jsx";

export function CompilerCard({compiler, session}) {
  const intl = useIntl();

  const [confirming, setConfirming] = useState(null);

  const validator = (event) => {
    if (["identifier", "publicKey"].includes(event.target.name)) {
      return !Aqumen.Utility.isBlank(event.target.value);
    }

    return true;
  };

  const handleChange = (event) => {
    let patch = null;

    if (event.target.name === "jobTermination") {
      if (event.target.checked) {
        if (!compiler.jobTermination.includes(event.target.value)) {
          patch = {
            jobTermination: compiler.jobTermination.concat([event.target.value])
          }
        }
      } else {
        if (compiler.jobTermination.includes(event.target.value)) {
          patch = {
            jobTermination: compiler.jobTermination.filter(t => t !== event.target.value)
          }
        }
      }
    } else {
      if (compiler[event.target.name] !== event.target.value) {
        if (validator(event)) {
          patch = {[event.target.name]: event.target.value};
        }
      }
    }

    if (patch) {
      return Aqumen.Compiler.update(
        compiler.session, {id: compiler.id}, patch
      );
    }
  }

  let className = "compiler-card card focusable-item";
  if (compiler.archivedAt) {
    className += " archived";
  }
  if (confirming) {
    className += " confirming";
  }

  return (
    <div className={className}>
      <CompilerInputsTile
        confirming={confirming}
        compiler={compiler}
        onChange={handleChange}
        validator={validator}
      />

      <div className="compiler-card-meta">
        <div className="compiler-card-ids">
          <div className="compiler-card-aqumen-id">
            <span className="data-label">
              {intl.formatMessage({id: "operations.compilers.compiler.id.aqumen.label"})}
            </span>
            <span className="data-value">
              <DisplayId id={compiler.id} disabled={confirming}/>
            </span>
          </div>
        </div>
      </div>

      <CompilerActionsTile
        confirming={confirming}
        compiler={compiler}
        session={session}
        setConfirming={setConfirming}
      />
    </div>
  );
}
